export const htmlQuizData = [
  {
    module: "Module 1: What is HTML?",
    questions: [
      {
        id: "html-q1-1",
        question: "What does HTML stand for?",
        options: [
          "Hyper Text Markup Language",
          "High Text Machine Language",
          "Hyperlinks and Text Markup Language",
          "Home Tool Markup Language"
        ],
        answer: "Hyper Text Markup Language",
      },
      {
        id: "html-q1-2",
        question: "Why is HTML important for web accessibility?",
        options: [
          "It makes websites look colorful and vibrant.",
          "It provides the semantic structure that screen readers rely on.",
          "It automatically translates text into different languages.",
          "It prevents hackers from accessing website data."
        ],
        answer: "It provides the semantic structure that screen readers rely on."
      }
    ]
  },
  {
    module: "Module 2: HTML Document Structure",
    questions: [
      {
        id: "html-q2-1",
        question: "Which HTML declaration tells the browser that the document is an HTML5 document?",
        options: [
          "<!DOCTYPE html>",
          "<html>",
          "<head>",
          "<meta charset='utf-8'>"
        ],
        answer: "<!DOCTYPE html>"
      },
      {
        id: "html-q2-2",
        question: "Why is the `lang` attribute important in the `<html>` tag?",
        options: [
          "It sets the font style for the page.",
          "It tells search engines where the server is located.",
          "It allows screen readers to pronounce words using the correct language profile.",
          "It translates the page text automatically."
        ],
        answer: "It allows screen readers to pronounce words using the correct language profile."
      }
    ]
  },
  {
    module: "Module 3: Headings, Paragraphs & Text",
    questions: [
      {
        id: "html-q3-1",
        question: "What is the correct way to define the most important heading on a page?",
        options: [
          "<h6>",
          "<head>",
          "<h1>",
          "<header>"
        ],
        answer: "<h1>"
      },
      {
        id: "html-q3-2",
        question: "Why should you avoid skipping heading levels (e.g., going from <h1> to <h3>)?",
        options: [
          "It looks visually unpleasant to sighted users.",
          "It confuses screen reader users who use headings to understand page structure and navigate quickly.",
          "It causes the browser to render the text smaller.",
          "It is strictly illegal under HTML5."
        ],
        answer: "It confuses screen reader users who use headings to understand page structure and navigate quickly."
      }
    ]
  },
  {
    module: "Module 4: Links & Navigation",
    questions: [
      {
        id: "html-q4-1",
        question: "Which tag is used to create a hyperlink?",
        options: [
          "<link>",
          "<a>",
          "<href>",
          "<nav>"
        ],
        answer: "<a>"
      },
      {
        id: "html-q4-2",
        question: "Why is 'Click Here' considered poor link text for accessibility?",
        options: [
          "It is too short for search engines to index.",
          "It doesn't describe the destination, removing context for screen reader users navigating a list of links.",
          "It does not look like a button.",
          "It is grammatically incorrect."
        ],
        answer: "It doesn't describe the destination, removing context for screen reader users navigating a list of links."
      }
    ]
  },
  {
    module: "Module 5: Images & Alt Text",
    questions: [
      {
        id: "html-q5-1",
        question: "Which attribute must be included in an `<img>` tag to make it accessible to screen readers?",
        options: [
          "src",
          "title",
          "alt",
          "desc"
        ],
        answer: "alt"
      },
      {
        id: "html-q5-2",
        question: "If an image is purely decorative, how should the alt attribute be handled?",
        options: [
          "It should be omitted entirely.",
          "It should describe the image in detail.",
          "It should be left empty (alt=\"\").",
          "It should say 'decorative image'."
        ],
        answer: "It should be left empty (alt=\"\")."
      }
    ]
  },
  {
    module: "Module 6: Lists & Tables",
    questions: [
      {
        id: "html-q6-1",
        question: "Which tag defines an unordered list?",
        options: [
          "<ul>",
          "<ol>",
          "<li>",
          "<list>"
        ],
        answer: "<ul>"
      },
      {
        id: "html-q6-2",
        question: "In an accessible HTML table, what tag is used to define table headers?",
        options: [
          "<tr>",
          "<td>",
          "<th>",
          "<thead>"
        ],
        answer: "<th>"
      }
    ]
  },
  {
    module: "Module 7: Forms & Input Accessibility",
    questions: [
      {
        id: "html-q7-1",
        question: "How do you associate a text `<label>` firmly with a specific `<input>` field?",
        options: [
          "By placing the label next to the input.",
          "By using the `for` attribute on the label that matches the input's `id`.",
          "By putting both inside a div.",
          "By using the `name` attribute."
        ],
        answer: "By using the `for` attribute on the label that matches the input's `id`."
      },
      {
        id: "html-q7-2",
        question: "Why are placeholders not a valid replacement for form labels?",
        options: [
          "Placeholders disappear when typing, causing memory strain, and often have poor color contrast.",
          "Placeholders cannot contain numbers.",
          "Placeholders are only supported on certain browsers.",
          "Screen readers read placeholders infinitely in a loop."
        ],
        answer: "Placeholders disappear when typing, causing memory strain, and often have poor color contrast."
      }
    ]
  },
  {
    module: "Module 8: Semantic HTML5 Elements",
    questions: [
      {
        id: "html-q8-1",
        question: "Which HTML5 element represents the primary content of the body of a document?",
        options: [
          "<article>",
          "<section>",
          "<body>",
          "<main>"
        ],
        answer: "<main>"
      },
      {
        id: "html-q8-2",
        question: "Instead of building a navigational menu using generic `<div>` tags, what semantic tag should you use?",
        options: [
          "<header>",
          "<nav>",
          "<ul>",
          "<section>"
        ],
        answer: "<nav>"
      }
    ]
  },
  {
    module: "Module 9: ARIA Roles & Attributes",
    questions: [
      {
        id: "html-q9-1",
        question: "What does ARIA stand for?",
        options: [
          "Accessible Rich Internet Applications",
          "Applied Readable Interface Architecture",
          "Assisted Reading Information Assets",
          "Automated Rendering Intelligent Action"
        ],
        answer: "Accessible Rich Internet Applications"
      },
      {
        id: "html-q9-2",
        question: "What is the First Rule of ARIA use?",
        options: [
          "Always use ARIA roles on every element.",
          "Use native HTML elements with built-in semantics instead of ARIA whenever possible.",
          "Only use ARIA for visually impaired users.",
          "ARIA attributes should be used to style the layout."
        ],
        answer: "Use native HTML elements with built-in semantics instead of ARIA whenever possible."
      }
    ]
  },
  {
    module: "Module 10: Building a Screen Reader Friendly Page",
    questions: [
      {
        id: "html-q10-1",
        question: "What is the purpose of a 'Skip to Content' link?",
        options: [
          "To allow users to bypass repetitive navigation links and jump straight to the main content.",
          "To skip loading images for faster page speeds.",
          "To scroll the user down aggressively on page load.",
          "To bypass authentication requirements."
        ],
        answer: "To allow users to bypass repetitive navigation links and jump straight to the main content."
      },
      {
        id: "html-q10-2",
        question: "How can you visually hide text but keep it readable by screen readers?",
        options: [
          "Use `display: none;`",
          "Use `visibility: hidden;`",
          "Change the text color to match the background color.",
          "Use specific CSS properties (like absolute positioning) to move it strictly out of the visual viewport (often called the `sr-only` class)."
        ],
        answer: "Use specific CSS properties (like absolute positioning) to move it strictly out of the visual viewport (often called the `sr-only` class)."
      }
    ]
  }
];
